export default __webpack_public_path__ + "static/media/icon-archive.988e2dbf.svg";